module.exports = __webpack_public_path__ + "img/9788936456726.9879da5e.jpg";